export default {
  // 查询静态页面列表
  getStaticpages: {
    url: '/staticpageApi/getStaticpages',
    method: 'GET'
  },
  // 删除静态页面
  deleteStaticpage: {
    url: '/staticpageApi/deleteStaticpage',
    method: 'POST'
  },
  // 新增静态页面
  createStaticpage: {
    url: '/staticpageApi/createStaticpage',
    method: 'POST'
  },
  // 修改静态页面
  updateStaticpage: {
    url: '/staticpageApi/updateStaticpage',
    method: 'POST'
  },
  // 页面详情
  getStaticpageById: {
    url: '/staticpageApi/getStaticpageById',
    method: 'GET'
  },
  // 页面标题列表
  getStaticpagesTitle: {
    url: '/staticpageApi/getStaticpagesTitle',
    method: 'POST'
  },
  // 根据id预览静态页面
  reviewStaticpageById: {
    url: '/staticpageApi/reviewStaticpageById',
    method: 'GET'
  },
  // 根据id修改静态页面权限
  updateStaticpagePower: {
    url: '/staticpageApi/updateStaticpagePower',
    method: 'POST'
  },
  // 根据id查询静态页面历史记录
  getStaticpageHistory: {
    url: '/staticpageApi/getStaticpageHistory',
    method: 'POST'
  },
}